<template>
  <div class="box"
    :class="{'iphonex':isIphoneX}">
    <div class="top-box">
      <div class="user-box">
        <img class="img-avatar"
          :src="form.headimgurl">
        <div class="user-text">{{form.nickname}}</div>
      </div>
      <img class="img-note"
        src="../../assets/interest/result/img_note.png">
    </div>
    <div class="container">
      <!-- 测评活力指数 -->
      <div class="chart-box">
        <div class="subject-title">{{posterType ===1?'成长':'健康'}}指数</div>
        <!-- 雷达图 -->
        <radar-chart v-if="form.group"
          :rows="form.group"
          @finished="chartFinished"
          id="radar-chart"
          class="m-t-15">
        </radar-chart>
      </div>
      <div class="vigour-box">
        <!-- <div class="baby-title">灵巧型宝宝</div> -->
        <div v-html="form.resultHtml"
          class="baby-intro">
        </div>
        <div class="cut-box">
          <div class="half-circle left"></div>
          <div class="half-circle right"></div>
        </div>
      </div>
      <!-- 分维度建议 -->
      <div class="dimension-box">
        <div class="subject-title">分维度建议</div>
        <div v-html="form.proposeHtml"
          class="recommend-box"></div>
        <!-- <div class="m-t-15">
          <div class="kind-box">
            <img class="kind-ic"
              src="../../assets/interest/result/ic_moon.png">
            <div class="kind-text">睡眠质量</div>
          </div>
          <div class="advise-text">
            跨时区飞行易导致疲劳，睡眠质量差等时差综合症，可使用褪黑素帮助调节昼夜节奏。跨时区飞行易导致疲劳，睡眠质量差等时差综合症。
          </div>
        </div> -->
      </div>
    </div>
    <!-- 底部悬浮按钮 -->
    <div v-show="!shareVisible"
      class="fixed-btm-box">
      <!-- 分享 -->
      <img @click="onShare"
        class="btn-share"
        src="../../assets/interest/result/btn_share.png">
      <!-- 重新测评 -->
      <div @click="onAgain"
        class="btn-again">重新测评</div>
    </div>
    <!-- 分享 -->
    <share ref="share"
      :shareVisible.sync="shareVisible">
    </share>
  </div>
</template>

<script>
import RadarChart from './components/RadarChart'
import Share from './components/Share'
import html2canvas from '../../utils/html2canvas'
import coreUtil from '../../utils/core'
import { actions, injectMixins } from '@/services'
import { setupShence } from '@/helpers'

export default {
  components: { RadarChart, Share },
  mixins: [injectMixins],
  data () {
    return {
      form: {},
      userInfo: {},
      isIphoneX: coreUtil.isiPhoneX(),
      posterType: null, // 测评类型 1 宝宝测评 2 妈妈测评
      shareVisible: false // 是否显示分享
    }
  },
  async created () {
    // 神策初始化
    await setupShence()
    // 获取问答详情
    this.getUserLastedAssess()
  },
  watch: {
    shareVisible () {
      const bodyEl = document.querySelector('body')
      const overflow = this.shareVisible ? 'hidden' : 'visible'
      bodyEl.style.overflow = overflow
    }
  },
  methods: {
    // 获取问答详情
    async getUserLastedAssess () {
      if (this.isPreview) { // 预览直接从缓存获取
        this.form = coreUtil.getLocal(`result-code-${this.code}`) || {}
      } else { // 非预览调用接口
        const ret = await actions.getUserLastedAssess(this.code)
        if (ret.code === 200) {
          this.form = ret.data || {}
        }
      }
      // 测评类型
      const material = this.form.material || {}
      this.posterType = material.poster_type
      // 设置title
      if (this.form.name) {
        document.title = this.form.cpName
      }
      // customContent转为json格式
      const { customContent } = this.form
      if (customContent) {
        this.form.customContent = JSON.parse(customContent)
      }
    },
    // 雷达图渲染完成事件
    chartFinished () {
      // 获取海报图缓存
      const posterImg = coreUtil.getLocal(`posterImg-code-${this.code}`)
      if (posterImg) {
        return
      }
      // 上传雷达截图
      this.upFile()
    },
    // 上传雷达截图
    async upFile () {
      const el = document.querySelector('.chart-container')
      const file = await html2canvas.domToFile(el)
      let formdata = new FormData()
      formdata.append('file', file)
      formdata.append('cpCode', this.code)
      const ret = await actions.upFile(formdata)
      const data = ret && ret.data
      if (data && data.path) {
        const path = `${data.path}?imageMogr2/format/jpg/quality/70`
        coreUtil.setLocal(`posterImg-code-${this.code}`, path)
        this.$refs.share.onShow()
      }
    },
    // 分享
    onShare () {
      this.$refs.share.onShow()
    },
    // 重新测评
    onAgain () {
      const query = this.$route.query
      this.$router.push({ path: '/interest/examine', query })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/core.scss";
@import "@/styles/variable.scss";

.box {
  background-color: $alabaster;
  min-height: 100vh;
  &.iphonex {
    .container {
      padding-bottom: 95px;
    }
    .fixed-btm-box {
      height: 95px;
    }
  }
  .top-box {
    background-color: rgba(107, 97, 115, 0.3);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 148px;
    padding: 0 25px 0 15px;
    .user-box {
      display: flex;
      align-items: center;
      padding-top: 30px;
      .img-avatar {
        height: 30px;
        width: 30px;
      }
      .user-text {
        font-size: 15px;
        padding-left: 10px;
      }
    }
    .img-note {
      height: 72px;
      margin-top: 18px;
      width: 148px;
    }
  }
  .container {
    background-color: $white;
    border-radius: 8px;
    padding-bottom: 80px;
    margin: -58px 15px 0;
    .subject-title {
      font-size: 18px;
      font-weight: 500;
    }
    // 图表box
    .chart-box {
      background: linear-gradient(46deg, #685e70 0%, #7c7186 100%);
      border-radius: 8px 8px 0 0;
      .subject-title {
        color: $white;
        padding: 15px 15px 0;
      }
    }
    // 活力指数
    .vigour-box {
      padding: 0 15px 15px;
      .baby-title {
        color: $turquoise;
        font-size: 18px;
        padding: 20px 0;
        text-align: center;
      }
      .baby-intro {
        font-size: 12px;
        padding-top: 15px;
      }
      .cut-box {
        border: 1px dashed $alto;
        margin: 33px -15px 0;
        position: relative;
        .half-circle {
          background-color: $alabaster;
          height: 20px;
          position: absolute;
          top: -10px;
          width: 10px;
          &.left {
            border-radius: 0 20px 20px 0;
            left: -1px;
          }
          &.right {
            border-radius: 20px 0 0 20px;
            right: -1px;
          }
        }
      }
    }
    // 维度建议
    .dimension-box {
      padding: 0 8px 10px;
      .subject-title {
        padding-left: 5px;
      }
      .kind-box {
        background-color: $turquoise;
        border-radius: 8px 8px 0px 0px;
        display: flex;
        align-items: center;
        height: 30px;
        padding-left: 7px;
        width: 104px;
        .kind-ic {
          height: 20px;
          width: 20px;
        }
        .kind-text {
          color: $white;
          font-size: 15px;
          font-weight: 500;
          padding-left: 7px;
        }
      }
      .advise-text {
        background-color: $alabaster;
        border-radius: 0px 4px 4px 4px;
        color: $gray;
        font-size: 12px;
        padding: 10px;
      }
      .recommend-box {
        margin: 10px 0 30px;
      }
    }
  }
  .fixed-btm-box {
    background-color: $white;
    border-radius: 8px;
    height: 80px;
    position: fixed;
    left: 15px;
    right: 15px;
    bottom: 0;
    .btn-share {
      display: block;
      margin-left: 4%;
      width: 92%;
      &:active {
        opacity: 0.5;
      }
    }
    .btn-again {
      color: $gray;
      font-size: 12px;
      padding: 10px 0;
      text-align: center;
      &:active {
        opacity: 0.5;
      }
    }
  }
}
</style>
